import i18n from 'i18n-js';

import { getPanelTestId, getPanelTitle, getShowAllTestId } from '@v2/pages/dashboard/common/helpers';
import type { DashboardOverviewBottomBlockPanelProps } from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewBottomBlock/components/DashboardOverviewBottomBlockPanel';

interface UseManageDashboardOverviewBottomBlockPanelParams
  extends Pick<DashboardOverviewBottomBlockPanelProps, 'scope' | 'variant'> {}

export const useManageDashboardOverviewBottomBlockPanel = ({ scope, variant }: UseManageDashboardOverviewBottomBlockPanelParams) => {
  const title = i18n.t(getPanelTitle(scope, variant));
  const panelTestId = getPanelTestId(variant);
  const showAllTestId = getShowAllTestId(variant);

  return { title, panelTestId, showAllTestId };
};
